import ScopeChangeRequest from 'admin/scope-change-requests/ScopeChangeRequest'
import ModalViewModel from 'infra/ModalViewModel'
import { makeObservable, observable } from 'mobx'

export default class ScopeChangeRequestFinalizedDialogViewModel extends ModalViewModel {
  @observable scopeChangeRequest = ScopeChangeRequest.none

  constructor() {
    super()
    makeObservable(this)
  }

  open(scopeChangeRequest: ScopeChangeRequest) {
    this.scopeChangeRequest = scopeChangeRequest
    this.show()
  }
}
